import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit'

import persistedReducer from './reducers'

const listenerMiddleware = createListenerMiddleware()

export const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(listenerMiddleware.middleware),
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppStore = typeof Store
export type AppState = ReturnType<AppStore['getState']>
export type AppDispatch = typeof Store.dispatch
